<template>
  <section class="hero" :class="planTheme">
    <div class="content-wrapper">
      <div class="hero-content">
        <h1>{{ title }}</h1>
        <slot/>
        <a class="button" v-if="buttonText" v-bind:href="buttonUrl">{{ buttonText }}</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['title', 'buttonText', 'buttonUrl', 'planTheme'],
  name: 'Hero',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .hero {
    position: relative;
    background: $primary url('../../assets/backgrounds/plan-hero-smoke.jpg') no-repeat right;
    background-size: contain;
    overflow: hidden;
    color: $text-light;
    min-height: 360px;
    padding: 40px 0 60px;
    margin-bottom: 40px;

    .hero-content {
      max-width: 50%;
    }
    h1, h2 {
      margin: 0;
    }
    p {
      max-width: 640px;
    }
    a.button {
      margin: 10px 0 0;
    }
  }
</style>
